import roleApi from "@/api/RoleApi";

const RoleStore = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    listRole({ commit }, data) {
      return roleApi.listRole(data);
    },
    listAllRole({ commit }, data) {
      return roleApi.listAllRole(data);
    },
    addOrUpdateRole({ commit }, data) {
      return roleApi.addOrUpdateRole(data);
    },
    deleteRole({ commit }, data) {
      return roleApi.deleteRole(data).then((res) => {
        return res;
      });
    },
  },
};

export default RoleStore;
